<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <!-- 关键字 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="物资名称">
            <el-input
              v-model="queryParams.key_word"
              placeholder="请输入物资名称"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 领用时间 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="领用时间">
            <el-date-picker
              v-model="queryParams.inDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 按钮区域 -->
      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button :disabled="isExporting" @click="debouncedExportExcel">
          {{ isExporting ? "导出中..." : "导出" }}
        </el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <!-- 勾选列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="assetsCatName" label="物资类别" />
      <el-table-column prop="consumableAssetsName" label="物资名称" />
      <el-table-column prop="assetsUnit" label="单位" />
      <el-table-column prop="assetsSku" label="规格" />
      <el-table-column prop="giveQuantity" label="数量" />
      <el-table-column prop="unitPrice" label="单价" />
      <el-table-column prop="totalPrice" label="金额" />
      <el-table-column prop="reciverName" label="领用人" />
      <el-table-column prop="createTime" label="申请时间" />
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
//   import * as XLSX from "xlsx";
//   import { saveAs } from "file-saver";
import {
  outStockConsumableAssetsList,
  getExcelConsumableAssetsList,
} from "@/api/material";
import { downloadFile, parseDateRange, debounce } from "@/utils/util";

import PaginationBar from "@/components/PaginationBar";

export default {
  name: "OutStockRecord",
  components: {
    PaginationBar,
  },
  data() {
    return {
      selectedIds: [], // 存储勾选的 id 列表
      isExporting: false, // 导出按钮的禁用状态
      queryParams: {
        key_word: "",
        inDateRange: [],
      },
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      debouncedExportExcel: null,
    };
  },
  created() {
    this.handleQuery();

    // 初始化防抖方法
    this.debouncedExportExcel = debounce(this.exportExcel.bind(this), 500);
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.logId); // 提取勾选行的 id
    },
    handleQuery(page) {
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.inDateRange
      );

      this.currentPage = page || 1;
      outStockConsumableAssetsList({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.key_word,
        begin_date,
        end_date,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        key_word: "",
        inDateRange: [],
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    exportExcel() {
      if (!this.selectedIds.length) {
        // 如果没有勾选项，提示用户
        return this.$message.warning("请先勾选要导出的数据");
      }

      // 开始导出，禁用按钮
      this.isExporting = true;

      getExcelConsumableAssetsList(this.selectedIds)
        .then((res) => {
          downloadFile(
            res.data,
            "低值易耗出库记录.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        })
        .catch((error) => {
          console.error("导出失败:", error);
          this.$message.error("导出失败，请稍后重试");
        })
        .finally(() => {
          // 导出完成，启用按钮
          this.isExporting = false;
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
